import { Box, Chip } from "@mui/material";
import { useFieldValue } from "react-admin";


const TagsField = (props: any) => {
    const { fieldKey = "name", } = props;
    const sourceValue = useFieldValue(props);


    return (

        <Box sx={{ padding: "0.5em" }} >
            {sourceValue?.map((item: any) => (
                // <li key={item[fieldKey]}>{item[fieldKey]}</li>
                <Chip key={item[fieldKey]} variant="outlined" color="primary" label={item[fieldKey]} sx={{ margin: "0.2em" }} />
            ))}
        </Box>
    )
}

export default TagsField